// extracted by mini-css-extract-plugin
export default {"holidayTable":"HolidayListEditor_holidayTable__Tspe0","nameCell":"HolidayListEditor_nameCell__QKm4q","rowActions":"HolidayListEditor_rowActions__6vi6R"};